import { getTime } from 'date-fns';
import { setCookie } from '@cian/utils/lib/browser/cookie';

export function setHideUnsupportedModal(): void {
  const day = 1000 * 60 * 60 * 24;
  const today = new Date();

  setCookie('hide_unsupported_modal', '1', {
    secure: false,
    expires: new Date(getTime(today) + day),
  });
}
